import { AxiosPromise, AxiosStatic } from "axios";
import { CreateDevReportDto, DevReportResponse } from "../types/DevReport";

export const createDevReport =
  (serverURL: string, appAxios: AxiosStatic) =>
  async ({
    screenshot,
    ...context
  }: CreateDevReportDto): AxiosPromise<DevReportResponse> => {
    const formData = new FormData();
    formData.append("screenshot", screenshot);
    Object.entries(context).forEach(([key, value]) => {
      formData.append(key, value);
    });

    return await appAxios.post(`${serverURL}/dev-reports`, formData, {
      withCredentials: true,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  };
